import React from 'react';
import { ArchetypeChips } from '../components/ArchetypeChips';
import { Button } from '../components/Button';
import { HowItWorks } from '../components/HowItWorks';
type IntroProps = {
  hasSavedProgress: boolean;
  onStart: () => void;
  onRestart: () => void;
};
export function Intro({
  hasSavedProgress,
  onStart,
  onRestart
}: IntroProps) {
  return <div className="mx-auto w-full max-w-3xl px-6 pb-24 pt-14 text-center sm:pt-16" data-id="element-79" data-mp="1e6s5951lk25o">
      <h1 className="mx-auto max-w-2xl font-display text-[32px] font-bold leading-[1.14] text-ink sm:text-5xl" data-id="element-80" data-mp="2auoibzxtsfc5">
        Discover <em className="italic text-teal" data-id="element-81" data-mp="26rigd4hqxabh">Your Relationship</em> Animal
      </h1>

      <p className="mx-auto mt-5 max-w-lg text-base font-light leading-[1.75] text-ink-light" data-id="element-82" data-mp="21soy6yrikv4z">
        Your relational pattern is not a personality type. It is how your feeling system learned to
        manage closeness, distance, and everything in between. Thirty statements. Eight archetypes.
        One honest look.
      </p>

      <div className="mt-9" data-id="element-83" data-mp="239whkdn6ucn">
        <ArchetypeChips data-id="element-84" data-mp="2306vxwiep7h" />
      </div>

      <div className="mt-10" data-id="element-85" data-mp="241fzwtyt1mk">
        <HowItWorks data-id="element-86" data-mp="64v34nzl2cee" />
      </div>

      <div className="mt-9 flex flex-col items-center gap-3" data-id="element-87" data-mp="63tt8muazvy9">
        <Button onClick={onStart} data-id="element-88" data-mp="3oaghq7182z4o">
          {hasSavedProgress ? 'Resume the Assessment →' : 'Begin the Assessment →'}
        </Button>

        {hasSavedProgress && <button type="button" onClick={onRestart} className="text-[13px] text-ink-muted underline underline-offset-4 transition-colors duration-150 ease-out hover:text-ink-light" data-id="element-89" data-mp="3t7q6rlkp98rz">
            Start over from the beginning
          </button>}
      </div>
    </div>;
}